var _circle, _path, _path2, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDressCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 26.5,
    stroke: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.697 16.0391H35.2891H39.2101C40.3147 16.0391 41.2101 16.9345 41.2101 18.0391V38.9075C41.2101 40.0121 40.3147 40.9075 39.2101 40.9075H14.7891C13.6845 40.9075 12.7891 40.0121 12.7891 38.9075V18.0391C12.7891 16.9345 13.6845 16.0391 14.7891 16.0391H18.7101H19.8943",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8945 13.0801V22.3088C19.8945 22.6871 20.2985 22.9284 20.6316 22.749L27.433 19.0867M19.8945 13.0801H35.2893M19.8945 13.0801L27.433 19.0867M35.2893 13.0801V22.3088C35.2893 22.6871 34.8853 22.9284 34.5522 22.749L27.7508 19.0867M35.2893 13.0801L27.7508 19.0867M27.433 19.0867V19.0867C27.5322 19.0333 27.6516 19.0333 27.7508 19.0867V19.0867",
    stroke: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 27.5,
    y1: 19.5938,
    x2: 27.5,
    y2: 40.9095,
    stroke: "currentColor"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 31.0527,
    y1: 28.5664,
    x2: 38.3422,
    y2: 28.5664,
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDressCode);
export default __webpack_public_path__ + "static/media/dress_code.aa7f1e8797418c6fe78ff7d4302f9a9d.svg";
export { ForwardRef as ReactComponent };